module.exports = __webpack_public_path__ + "static/media/bg-saae.3e8a21fd.jpg";